<template>
  <div class="resume-body custom-resume-body">
    <div class="border">
      【個人資料蒐集、處理及利用告知事項】<br />
      為保護台端權益，請詳閱以下告知事項，台端於下表提供個人資料並簽名即表示已理解並同意以下規定：
      本公司基於招募聘用、
      人事管理、業務執行及相關營運需要之目的(下合稱「特定目的」)有必要於所在地
      以紙本、電子文件、電磁紀錄或其他合於當時
      科學技術之適當方式，在符合個人資料保護相關法令之範圍
      內，蒐集、於國內與國際間處理與利用台端於下表即未來所提供之個
      人資料(下稱「個人資料」)，並得於
      特定目的消失後保存至少15年。台端個人資料利用對象包括本公司及本公司國內外關係企業
      (下稱「本公
      司關係企業」)、本公司及本公司關係企業之職工福利委員會、財團法人日月之光慈善事業基金會、財團法
      人日月光
      文教基金會、以上公司、關係企業及組織之職員、代理人、專業顧問、及其所委託之第三人以及
      依法令得提供其台端個人資料之
      人。台端得依個人資料保護法第三條行使之相關權利包括(1)查詢或請求閱
      覽(2)請求製給複製本(3)請求補充或更正(4)請求停止蒐
      集、處理或利用(5)請求刪除。台端得自由選擇是
      否提供相關個人資料，台端若拒絕提供相關個人資料或未確實完整填寫，本公司
      可能無法進行相關審核及 處理作業而影響台端支應徵或任職機會。
      <div style="text-align: right">
        簽名：___________________ 民國____年____月____日
      </div>
    </div>

    <div class="border">
      <div class="border-bottom">
        1.是否曾任職於本公司:<template
          v-if="typeof dlResume.WorkedInfo.HasWorkedInCompany === 'boolean'"
        >
          {{ dlResume.WorkedInfo.HasWorkedInCompany ? "是" : "否" }}
          <br />
          <span v-if="dlResume.WorkedInfo.HasWorkedInCompanyDesc">
            ，說明：{{ dlResume.WorkedInfo.HasWorkedInCompanyDesc }}
          </span>
        </template>
        <template v-else>無</template>
      </div>
      <div class="border-bottom">
        2.是否收到日月光主動邀約:<template
          v-if="typeof dlResume.WorkedInfo.IsInvited === 'boolean'"
        >
          {{ dlResume.WorkedInfo.IsInvited ? "是" : "否" }}
        </template>
        <template v-else>無</template>
      </div>
      <div>
        3.招募管道來源:<template v-if="dlResume.WorkedInfo.RecruitmentSource">
          {{ dlResume.WorkedInfo.RecruitmentSource
          }}{{ dlResume.WorkedInfo.RecruitmentSourceDescActivityShool
          }}{{ dlResume.WorkedInfo.RecruitmentSourceDescActivityOrg
          }}{{ dlResume.WorkedInfo.RecruitmentSourceDescActivityOther
          }}{{ dlResume.WorkedInfo.RecruitmentSourceDescCenterOther
          }}{{ dlResume.WorkedInfo.RecruitmentSourceDescFlyerOther
          }}{{ dlResume.WorkedInfo.RecruitmentSourceDescJobBankOther
          }}{{ dlResume.WorkedInfo.RecruitmentSourceDescHunter }}
          {{ dlResume.WorkedInfo.RecruitmentSourceDescOtherSource }}
        </template>
        <template v-else>無</template>
      </div>
    </div>

    一、個人資料
    <table>
      <tr>
        <th id="name">中文姓名</th>
        <td>{{ name }}</td>

        <td>性別</td>
        <td>{{ dlResume.BaseInfo.Sex }}</td>

        <td>應徵工作班別</td>
        <td>
          <span
            v-for="(item, index) in dlResume.BaseInfo.WorkShiftTypes"
            :key="index"
          >
            {{ item }}<br />
          </span>
        </td>

        <td>錄取後可上班時間</td>
        <td>
          {{
            dlResume.WorkedInfo.AvailableOnBoardDate
              ? $common.dateFormatter(dlResume.WorkedInfo.AvailableOnBoardDate)
              : "無"
          }}
        </td>
        <td rowspan="3" class="width_125">
          <img
            style="width: 125px; height: 125px; object-fit: cover"
            :src="
              headPhotoBase64
                ? headPhotoBase64
                : require(`@/assets/img/head2.png`)
            "
            alt=""
          />
        </td>
      </tr>
      <tr>
        <td>生日</td>
        <td>{{ $common.dateFormatter(dlResume.BaseInfo.BirthDay) }}</td>
        <td>國籍</td>
        <td>{{ dlResume.BaseInfo.Nationality }}</td>
        <td>外籍在台原因</td>
        <td>
          {{
            dlResume.BaseInfo.ForeignerReason
              ? dlResume.BaseInfo.ForeignerReason
              : "無"
          }}
          {{
            dlResume.BaseInfo.ForeignerReasonDesc
              ? "-" + dlResume.BaseInfo.ForeignerReasonDesc
              : null
          }}
        </td>
        <td>身分證字號/護照號碼</td>
        <td>{{ dlResume.BaseInfo.IdNo }}</td>
      </tr>
      <tr>
        <td>個人手機</td>
        <td>{{ dlResume.BaseInfo.MobilePhone }}</td>
        <td>家用電話(區域碼-號碼)</td>
        <td>{{ dlResume.BaseInfo.Phone ? dlResume.BaseInfo.Phone : "無" }}</td>

        <td>身高</td>
        <td>
          {{
            dlResume.BaseInfo.Height ? dlResume.BaseInfo.Height + "cm" : "無"
          }}
        </td>
        <td>體重</td>
        <td>
          {{
            dlResume.BaseInfo.Weight ? dlResume.BaseInfo.Weight + "kg" : "無"
          }}
        </td>
      </tr>

      <tr>
        <td>*Email</td>
        <td colspan="8">
          {{ dlResume.BaseInfo.Email }}
        </td>
      </tr>

      <tr>
        <td>配合加班</td>
        <td>{{ dlResume.BaseInfo.CanOverTime ? "是" : "否" }}</td>
        <td>原因說明</td>
        <td colspan="6">
          <span v-if="dlResume.BaseInfo.CanOverTimeDesc">
            {{ dlResume.BaseInfo.CanOverTimeDesc }}
          </span>
        </td>
      </tr>

      <tr>
        <td>配合輪班</td>
        <td>{{ dlResume.BaseInfo.CanShiftWork ? "是" : "否" }}</td>
        <td>原因說明</td>
        <td colspan="6">
          <span v-if="dlResume.BaseInfo.CanShiftWorkDesc">
            {{ dlResume.BaseInfo.CanShiftWorkDesc }}
          </span>
        </td>
      </tr>

      <tr>
        <td>是否領有身心障礙手冊</td>
        <td>{{ dlResume.BaseInfo.HasDisabilityCard ? "是" : "否" }}</td>
        <td>說明</td>
        <td colspan="6">
          {{
            dlResume.BaseInfo.HasDisabilityCardDesc
              ? dlResume.BaseInfo.HasDisabilityCardDesc
              : null
          }}
        </td>
      </tr>

      <tr>
        <td>視力</td>
        <td>
          <template v-if="dlResume.BaseInfo.VisualAcuity">
            {{ dlResume.BaseInfo.VisualAcuity
            }}{{
              dlResume.BaseInfo.VisualAcuityDesc
                ? dlResume.BaseInfo.VisualAcuityDesc
                : null
            }}
          </template>
          <template v-else>無</template>
        </td>

        <td colspan="2">
          <span>左眼度數：{{ dlResume.BaseInfo.SPHLeft }}</span
          >、<span>右眼度數：{{ dlResume.BaseInfo.SPHRight }}</span>
        </td>

        <td>是否有散光</td>
        <td>{{ dlResume.BaseInfo.HasAstigmatic ? "是" : "否" }}</td>
        <td colspan="3">
          <span>左眼度數：{{ dlResume.BaseInfo.CYLLeft }}</span
          >、<span>右眼度數：{{ dlResume.BaseInfo.CYLRight }}</span>
        </td>
      </tr>
      <tr>
        <td>住處</td>
        <td>{{ dlResume.BaseInfo.ResidenceType }}</td>

        <td>出勤方式</td>
        <td>{{ dlResume.BaseInfo.CommutingType }}</td>
        <td>通勤時間</td>
        <td colspan="4">{{ dlResume.BaseInfo.CommutingMinutes }}</td>
      </tr>
      <tr>
        <td>*通訊地址</td>
        <td colspan="8">
          {{ dlResume.BaseInfo.ContactCounty
          }}{{ dlResume.BaseInfo.ContactDistrict }}
          {{ dlResume.BaseInfo.ContactVillage
          }}{{ dlResume.BaseInfo.ContactAddress }}
        </td>
      </tr>
      <tr>
        <td>戶籍地址</td>
        <td colspan="8">
          {{ dlResume.BaseInfo.County }}{{ dlResume.BaseInfo.District }}
          {{ dlResume.BaseInfo.Village }}{{ dlResume.BaseInfo.Address }}
        </td>
      </tr>

      <tr>
        <td>緊急聯絡人姓名</td>
        <td>{{ dlResume.BaseInfo.EmergencyContact }}</td>
        <td>緊急聯絡人關係</td>
        <td>{{ dlResume.BaseInfo.EmergencyContactRelationship }}</td>
        <td>緊急聯絡人電話(手機)</td>
        <td colspan="4">{{ dlResume.BaseInfo.EmergencyContactPhone }}</td>
      </tr>

      <tr>
        <td>緊急聯絡人地址</td>
        <td colspan="8">
          {{ dlResume.BaseInfo.EmergencyContactCounty
          }}{{ dlResume.BaseInfo.EmergencyContactDistrict
          }}{{ dlResume.BaseInfo.EmergencyContactVillage
          }}{{ dlResume.BaseInfo.EmergencyContactAddress }}
        </td>
      </tr>

      <tr>
        <td colspan="2">目前是否在學或計劃於短期繼續升學或進修？</td>
        <td>{{ dlResume.BaseInfo.InSchoolOrHasStudyPlan ? "是" : "否" }}</td>
        <td>請詳述計畫內容</td>
        <td colspan="5">
          {{ dlResume.BaseInfo.InSchoolOrHasStudyPlanDesc }}
        </td>
      </tr>
    </table>

    二、工作條件
    <table>
      <tr>
        <th id="question">是否可接受在無塵室穿戴無塵服及手套工作</th>
        <td>{{ dlResume.WorkCondition.CanWorkAtCleanRoom ? "是" : "否" }}</td>
        <td>說明</td>
        <td>{{ dlResume.WorkCondition.CanWorkAtCleanRoomDesc }}</td>
      </tr>
      <tr>
        <td>是否可接受使用顯微鏡之工作</td>
        <td>{{ dlResume.WorkCondition.CanUseMicroscope ? "是" : "否" }}</td>
        <td>說明</td>
        <td>{{ dlResume.WorkCondition.CanUseMicroscopeDesc }}</td>
      </tr>
      <tr>
        <td>是否可配合單位工具及產品搬運</td>
        <td>{{ dlResume.WorkCondition.CanCarryObjects ? "是" : "否" }}</td>
        <td>說明</td>
        <td>{{ dlResume.WorkCondition.CanCarryObjectsDesc }}</td>
      </tr>
      <tr>
        <td>是否可接受長時間定點性/走動性久站</td>
        <td>{{ dlResume.WorkCondition.CanStandLongTime ? "是" : "否" }}</td>
        <td>說明</td>
        <td>{{ dlResume.WorkCondition.CanStandLongTimeDesc }}</td>
      </tr>
      <tr>
        <td>是否可接受接觸化學藥品工作</td>
        <td>{{ dlResume.WorkCondition.CanWorkWithChemicals ? "是" : "否" }}</td>
        <td>說明</td>
        <td>{{ dlResume.WorkCondition.CanWorkWithChemicalsDesc }}</td>
      </tr>
      <tr>
        <td>是否可接受英文介面機台操作</td>
        <td>
          {{ dlResume.WorkCondition.CanOperateMachineInEnglish ? "是" : "否" }}
        </td>
        <td>說明</td>
        <td>{{ dlResume.WorkCondition.CanOperateMachineInEnglishDesc }}</td>
      </tr>
      <tr>
        <td>過去兩年內是否請過長假</td>
        <td>{{ dlResume.WorkCondition.HasLongTermVacation ? "是" : "否" }}</td>
        <td>說明</td>
        <td>{{ dlResume.WorkCondition.HasLongTermVacationDesc }}</td>
      </tr>
    </table>

    三、學校/學歷(填寫一項最高學歷，若尚未畢業則續填次高學歷;若為其它或國外校區，請於備註中表示校名)

    <table>
      <tr>
        <th id="degree">學位</th>
        <td>校區/校名/備註</td>
        <td>科系/類別</td>
        <td>學制</td>
        <td>入學日期(民國)</td>
        <td>離校日期(民國)</td>
        <td>是否畢業</td>
      </tr>
      <tr v-for="education in dlResume.Educations" :key="education.Id">
        <td>{{ education.EducationCategory }}</td>
        <td>
          {{
            education.SchoolGuid === "11111111-1111-1111-1111-111111111111"
              ? education.SchoolDescription
              : education.School
          }}
        </td>
        <td>{{ education.MajorName ? education.MajorName : "無" }}</td>
        <td>{{ education.IsDaySchool ? "日校" : "夜校" }}</td>
        <td>{{ $common.monthFormatter(education.EducationFrom) }}</td>
        <td>
          {{
            education.EducationTo
              ? $common.monthFormatter(education.EducationTo)
              : ""
          }}
        </td>
        <td>{{ education.IsGraduate ? "是" : "否" }}</td>
      </tr>
      <tr>
        <td colspan="8">
          目前是否在學或計畫於短期內繼續升學或進修<template
            v-if="dlResume.BaseInfo.InSchoolOrHasStudyPlan !== null"
          >
            {{ dlResume.BaseInfo.InSchoolOrHasStudyPlan ? "是" : "否" }}
            <span v-if="dlResume.BaseInfo.InSchoolOrHasStudyPlanDesc">
              ，說明：{{ dlResume.BaseInfo.InSchoolOrHasStudyPlanDesc }}
            </span>
          </template>
        </td>
      </tr>
    </table>

    四、工作/工讀經歷(請由最近工作之公司開始填起)
    <table>
      <tr>
        <th id="no">No.</th>
        <td>年資</td>
        <td>工作期間(民國)/薪資</td>
        <td>公司名稱</td>
        <td>服務部門</td>
        <td>職稱</td>
        <td>在職與否/(欲)離職原因</td>
      </tr>
      <tr
        v-for="(experience, index) in dlResume.WorkExperiences.WorkExperiences"
        :key="experience.Id"
      >
        <td>{{ index + 1 }}</td>
        <td>{{ experience.Seniority ? experience.Seniority : "無" }}年</td>
        <td>
          {{ $common.monthFormatter(experience.ExperienceFrom) }}~{{
            experience.ExperienceTo
              ? $common.monthFormatter(experience.ExperienceTo)
              : ""
          }}<br />
          底薪:{{ experience.MonthlySalary ? experience.MonthlySalary : "無" }}
        </td>
        <td>{{ experience.Company }}<br /></td>
        <td>{{ experience.Department }}<br /></td>
        <td>
          {{ experience.Position }}
        </td>
        <td>
          {{ experience.OnTheJob ? "是" : "否" }}<br />
          離職原因:{{ experience.LeaveReason }}
        </td>
      </tr>
      <tr>
        <td>合計年資</td>
        <td colspan="6">{{ totalSeniority }}年</td>
      </tr>
    </table>

    五、專業技能及認證
    <table>
      <tr>
        <th id="skill">
          {{
            dlResume.Skill.ProfessionalSkill
              ? dlResume.Skill.ProfessionalSkill
              : "無"
          }}
        </th>
      </tr>
    </table>

    六、自傳
    <table>
      <tr>
        <th id="question">
          <span
            v-if="dlResume.Autobiography.Autobiography"
            v-html="dlResume.Autobiography.Autobiography"
          />
          <span v-else>無</span>
        </th>
      </tr>
    </table>

    <div class="border">
      【聲明事項】<br />
      1.
      本人已詳閱並瞭解
      貴公司依個人資料保護法及相關法令之規定所告知本履歷表內個人資料之蒐集目的、利用之期間、
      地區、對象及方式、依個人資料保護法第三條規定得行使之權利及權利行使方式以及不提供本履歷表內個人資料時將對
      本人權益之影響，本人於茲表示同意
      貴公司依據告知內容蒐集、處理及利用本人之個人資料。
      <br />
      2.
      本人聲明並擔保於本履歷表內所提供第三人之個人資料，業獲該等人員同意提供其個人資料並允許相關之蒐集、處理
      及利用，如有爭議發生，悉由本人負相關法律責任，並賠償 貴公司因此所受之損害。
      <br />
      3.
      本人確認於本履歷表內填載之各項資料與陳述均屬實，並同意
      貴公司就本履歷表內所提供資料內容之正確性進行查證，如有虛偽不實之情事，本人願無條件接受
      貴公司解僱處分，如涉及違法，全憑 貴公司依法處理。
      <br />
      4.
      本人聲明並擔保本人至
      貴公司應徵未違反本人與現任雇主、前雇主或其他第三人之兼職禁止、競業禁止、利益衝突禁
      止、保密協議、智慧財產權協議或其他類似之約定，前開狀態若於接獲錄取通知至
      貴公司報到前有所變動，本人將主動告知並提供
      貴公司所需資訊。本人並承諾確實遵守智慧財產權相關法律及本人應履行之保密或智慧財產權相關約定，應
      徵期間所有之行為，絕不洩漏或侵害現任雇主、前雇主或其他第三人之營業秘密、機密資訊或其他智慧財產權。如有違
      反本條，悉由本人負相關法律責任，並賠償 貴公司因此所受之損害。
      <br />
      5.
      本人同意如因本人未提供正確個人資料導致權益受影響或遭遇緊急事件時無法獲得迅速妥善之處理，相關後果與責任
      悉由本人自行承擔。
      <br />
      6.
      本人同意如此次未獲 貴公司錄用或個人放棄報到，
      貴公司得保留本人資料並列入儲備人員，日後若有適當職缺時得再行通知本人。
      <br />
      7.
      本人已詳閱「妊娠與分娩後女性及未滿十八歲勞工禁止從事危險性或有害性工作」之相關規定。
      <br />
      <div style="text-align: right">
        簽名：___________________ 民國____年____月____日
      </div>
    </div>
    <br />
  </div>
</template>

<script>
export default {
  name: "DlResume",
  props: ["ResumeId", "ResumeType"],
  data() {
    return {
      activeName: "個人資料",
      name: null,
      dlResume: [],

      headPhotoBase64: null,

      dlMenu: ["個人資料", "工作條件", "自傳"],

      normalColor: "#fff0d2",
      selectedColor: "#ffe2a5",
    };
  },
  computed: {
    totalSeniority() {
      let total = this.dlResume.WorkExperiences.WorkExperiences.reduce(
        (total, person) => total + person.Seniority,
        0
      );
      return parseFloat(total.toFixed(1)); // 限制小數點後一位，並轉回數字
    },
  },

  methods: {
    // 取得 履歷
    async getResume() {
      this.$store.dispatch("updateLoading", true);
      await this.$api.viewResume.getResume(this.ResumeId).then((response) => {
        if (response.status === 200) {
          this.name = response.data.Name;
          this.headPhotoBase64 = response.data.HeadPhotoBase64;
          this.dlResume = response.data.DLResume;
        }
        this.$store.dispatch("updateLoading", false);
      });
    },
  },

  created() {
    this.getResume();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tag--mini {
  margin-left: -2px;
  margin-bottom: 2px;
}

.custom-resume-body {
  .border {
    border: 2px solid #000 !important;
    margin-bottom: 20px;
    .border-bottom {
      border-bottom: 1px solid #000 !important;
    }
  }

  table {
    border: 2px solid #000;
    width: 100%;
    margin-bottom: 20px;
    th {
      font-weight: normal;
    }
    td {
      border: 1px solid #000;
    }
  }
  .width_125 {
    width: 125px;
  }
}
</style>
